module.exports = __webpack_public_path__ + "static/media/ic_pay_amex.ff65b25c.svg";